/**
 * @generated SignedSource<<e0e6c56a1f4e858a9c64fd17c1dea64d>>
 * @relayHash f8527921e629a9daeea7ba0d1a9731cd
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/563.0.0-2026-06-09T16:12:08.244Z/NftProfileSectionCreationsPaginationQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileSectionCreationsPaginationQuery$variables = {
  creationsCursor?: string | null;
  creationsFirst?: number | null;
  fetchUser: boolean;
  userId: string;
  username?: string | null;
  walletAddress?: string | null;
};
export type NftProfileSectionCreationsPaginationQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"NftProfileSectionCreations_viewer">;
  };
};
export type NftProfileSectionCreationsPaginationQuery = {
  response: NftProfileSectionCreationsPaginationQuery$data;
  variables: NftProfileSectionCreationsPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "creationsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "creationsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "walletAddress"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "creationsCursor"
  },
  {
    "items": [
      {
        "kind": "Variable",
        "name": "creatorAddresses.0",
        "variableName": "walletAddress"
      }
    ],
    "kind": "ListValue",
    "name": "creatorAddresses"
  },
  {
    "items": [
      {
        "kind": "Variable",
        "name": "creatorProfileUsernames.0",
        "variableName": "username"
      }
    ],
    "kind": "ListValue",
    "name": "creatorProfileUsernames"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "creationsFirst"
  },
  {
    "kind": "Literal",
    "name": "onlyFirstdibsContracts",
    "value": true
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ether",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileName",
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  (v7/*: any*/),
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ensDomain",
    "storageKey": null
  },
  (v8/*: any*/)
],
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpUrl",
  "storageKey": null
},
v13 = [
  (v7/*: any*/),
  (v8/*: any*/)
],
v14 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "auctionId",
    "storageKey": null
  },
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "EthereumAddressType",
    "kind": "LinkedField",
    "name": "contractAddress",
    "plural": false,
    "selections": (v13/*: any*/),
    "storageKey": null
  },
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftProfileSectionCreationsPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftProfileSectionCreations_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NftProfileSectionCreationsPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "nftCreations",
            "args": (v1/*: any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NftItemSearchEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftDigitalArtMetadataMedia",
                                "kind": "LinkedField",
                                "name": "media",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mimeType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "webUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "posterFrameUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "videoThumb",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "edition",
                                "storageKey": null
                              }
                            ],
                            "type": "NftDigitalArtMetadata",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v4/*: any*/),
                        "concreteType": "NftAuction",
                        "kind": "LinkedField",
                        "name": "mostRecentAuction",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EtherAmount",
                            "kind": "LinkedField",
                            "name": "currentBid",
                            "plural": false,
                            "selections": (v6/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EtherAmount",
                            "kind": "LinkedField",
                            "name": "reservePrice",
                            "plural": false,
                            "selections": (v6/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "winnerAddress",
                            "plural": false,
                            "selections": (v10/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftItem",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherRates",
                                "kind": "LinkedField",
                                "name": "etherRates",
                                "plural": true,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftConversionRateEvent",
                            "kind": "LinkedField",
                            "name": "endedConversionRates",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherRates",
                                "kind": "LinkedField",
                                "name": "rates",
                                "plural": true,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "creatorAddress",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "sellerAddress",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": "mostRecentAuction(excludeCanceled:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "wasBurned",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinkData",
                        "kind": "LinkedField",
                        "name": "linkData",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "path",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isLinkable",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "importErrorReason",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftItemLikes",
                        "kind": "LinkedField",
                        "name": "likes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "likeCount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "creatorAddress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "publicProfileUrl",
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          (v8/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalSupply",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isERC1155",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "ownerAddress",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tokenId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tokenUri",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftTokenContract",
                        "kind": "LinkedField",
                        "name": "contract",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "addressWithFields",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "userId",
                                "variableName": "userId"
                              }
                            ],
                            "concreteType": "NftItemBalance",
                            "kind": "LinkedField",
                            "name": "balanceForUser",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "balance",
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "ownerAddress",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "alias": "recentAuction",
                        "args": (v4/*: any*/),
                        "concreteType": "NftAuction",
                        "kind": "LinkedField",
                        "name": "mostRecentAuction",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": "mostRecentAuction(excludeCanceled:true)"
                      },
                      (v12/*: any*/),
                      {
                        "alias": "auction",
                        "args": (v4/*: any*/),
                        "concreteType": "NftAuction",
                        "kind": "LinkedField",
                        "name": "mostRecentAuction",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": "mostRecentAuction(excludeCanceled:true)"
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "nftCreations",
            "args": (v1/*: any*/),
            "filters": [
              "creatorProfileUsernames",
              "creatorAddresses",
              "onlyFirstdibsContracts"
            ],
            "handle": "connection",
            "key": "NftProfileSectionCreations_nftCreations",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          (v8/*: any*/),
          {
            "alias": "nftBenignNeglect",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftBenignNeglect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
          },
          {
            "alias": "walletConnectFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "allowWalletConnect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "isNftAuctionV2Enabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftAuctionV2"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/563.0.0-2026-06-09T16:12:08.244Z/NftProfileSectionCreationsPaginationQuery",
    "metadata": {},
    "name": "NftProfileSectionCreationsPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "33765be59c44b96e2e17be695dbe0839";

export default node;
